// extracted by mini-css-extract-plugin
export default {"container":"SubCategories_container__baylW","active":"SubCategories_active__6TX8e"};